const ArrowDownIcons = () => {
	return (
		<svg
		className="mx-2"
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V18.0858L6.20711 13.2929C5.81658 12.9024 5.18342 12.9024 4.79289 13.2929C4.40237 13.6834 4.40237 14.3166 4.79289 14.7071L10.5858 20.5C11.3668 21.281 12.6332 21.281 13.4142 20.5L19.2071 14.7071C19.5976 14.3166 19.5976 13.6834 19.2071 13.2929C18.8166 12.9024 18.1834 12.9024 17.7929 13.2929L13 18.0858V4Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default ArrowDownIcons;